const breakpoints = ['320px', '648px', '720px', '1080px', '1224px', '1352px', '1440px', '1920px'];

breakpoints.mobile320 = breakpoints[0];
breakpoints.tablet648 = breakpoints[1];
breakpoints.tablet720 = breakpoints[2];
breakpoints.tablet1080 = breakpoints[3];
breakpoints.desktop1224 = breakpoints[4];
breakpoints.desktop1352 = breakpoints[5];
breakpoints.desktop1440 = breakpoints[6];
breakpoints.desktop1920 = breakpoints[7];

export default breakpoints;
